// components/superAdmin/featureFlags.js
// Account.show_* flags, grouped the same way as Account.get_enabled_menu_items() on the backend.
export const FEATURE_GROUPS = [
  {
    key: 'financial',
    label: 'المالية',
    flags: [
      { key: 'show_financial_management', label: 'سندات الصرف' },
      { key: 'show_recipient_management', label: 'سندات القبض' },
      { key: 'show_payments_schedule', label: 'جدول الدفعات' },
      { key: 'show_outgoing_cheques', label: 'الشيكات الصادرة' },
    ],
  },
  {
    key: 'school',
    label: 'المدرسة',
    flags: [
      { key: 'show_students', label: 'الطلاب' },
      { key: 'show_staff', label: 'الموظفين' },
      { key: 'show_classes', label: 'الصفوف' },
      { key: 'show_buses', label: 'الحافلات' },
      { key: 'show_store', label: 'المستودع' },
      { key: 'show_archive', label: 'الأرشيف' },
      { key: 'show_library', label: 'المكتبة' },
      { key: 'show_educational_schedule', label: 'الجدول التعليمي' },
    ],
  },
  {
    key: 'administrative',
    label: 'الإدارة',
    flags: [
      { key: 'show_logs', label: 'سجل التغييرات' },
      { key: 'show_settings', label: 'الإعدادات' },
      { key: 'show_year_transition', label: 'الانتقال للسنة الجديدة' },
      { key: 'show_password_reset', label: 'تعيين كلمة مرور جديدة' },
    ],
  },
];

export const FEATURE_FLAGS = FEATURE_GROUPS.flatMap((g) => g.flags);

// Mirrors the model defaults on Account
export const MODEL_FEATURE_DEFAULTS = {
  ...Object.fromEntries(FEATURE_FLAGS.map((f) => [f.key, true])),
  show_library: false,
  show_educational_schedule: false,
};

const DAY_MS = 24 * 60 * 60 * 1000;

export const daysUntil = (dateStr) => {
  if (!dateStr) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((new Date(`${dateStr}T00:00:00`) - today) / DAY_MS);
};

export const addDaysISO = (days) => {
  const d = new Date(Date.now() + days * DAY_MS);
  return d.toISOString().slice(0, 10);
};

// One status per school, used for chips and filters
export const accountStatus = (acc, warningDays = 14) => {
  if (!acc.is_active) return { key: 'suspended', label: 'موقوف', color: 'default' };
  const left = daysUntil(acc.subscription_end_date);
  if (left !== null && left < 0) return { key: 'expired', label: 'منتهي', color: 'error' };
  if (left !== null && left <= warningDays) return { key: 'expiring', label: `ينتهي خلال ${left} يوم`, color: 'warning' };
  return { key: 'active', label: 'نشط', color: 'success' };
};
